import { ReactNode, createContext, useContext, useMemo, useState, useCallback } from 'react';
import { useGetShipment } from 'src/use-cases/invoice/useInvoices';
import { IShipmentValues } from './types';

export interface IShipmentSelectorProps {
  children: ReactNode;
  // eslint-disable-next-line react/no-unused-prop-types
  defaultInvoiceId?: string;
  defaultShipmentInvoiceId?: string;
}

// eslint-disable-next-line react-refresh/only-export-components
export const ShipmentDefaultValues = {
  shipmentInvoiceId: null,
  shipment: null,
  isLoadingShipment: false,
  changeShipment: () => {},
};

export const ShipmentSelectorContext = createContext<IShipmentValues>(ShipmentDefaultValues);

export const ShipmentSelector = ({ children, defaultShipmentInvoiceId }: IShipmentSelectorProps) => {
  const [shipmentInvoiceId, setShipmentInvoiceId] = useState<string>(defaultShipmentInvoiceId ?? null);

  const { data: shipment, isLoading: isLoadingShipment } = useGetShipment(shipmentInvoiceId);

  const changeShipment = useCallback((newShipmentInvoiceId: string) => {
    setShipmentInvoiceId(newShipmentInvoiceId);
  }, []);

  const value = useMemo(
    () => ({
      shipment,
      shipmentInvoiceId,
      isLoadingShipment,
      changeShipment,
    }),
    [shipment, shipmentInvoiceId, isLoadingShipment, changeShipment]
  );

  return <ShipmentSelectorContext.Provider value={value}>{children}</ShipmentSelectorContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export function useShipmentSelector() {
  const context = useContext(ShipmentSelectorContext);

  if (!context) {
    throw new Error(`Shipment selector compound components cannot be rendered outside the Shipment Selector component`);
  }
  return context;
}
